






















































































































import {Component, Prop} from 'vue-property-decorator';
import Form from '@/components/form-base';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import DomainsApi from '@/services/rest/bemob/domains';
import FlowApi from '@/services/rest/bemob/flow';
import { FlowHierarchyTypeEnum } from '@/services/models/Enums';
import LpPixelTreeview from './lp-pixel-treeview.vue';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import CampaignApi from '@/services/rest/bemob/campaign';


@Component({
  components: {
    FormOverlay,
    DialogForm,
    LpPixelTreeview,
    HeaderButtons
  }
})
export default class LpPixelDialog extends Form {
  @Prop({ default: {} })
  data: any;

  show: boolean = false;

  step: number = 1;
  edit: boolean = true;
  loading: boolean = false;


  domainsApi: DomainsApi = new DomainsApi();
  flowApi: FlowApi = new FlowApi();
  campaignApi: CampaignApi = new CampaignApi();

  flow: any = {};

  protocol: string = 'https';
  trackingDomainId: string = '';
  campaign_id: string = '';
  campaign: any = {};
  selectedLanding: any = null;

  get landingOffers() {
    return this.selectedLanding.offers || 1
  }

  get selectedDomain() {
    return this.$store.getters.cache.trackingDomainsObject[this.trackingDomainId] || {};
  }

  get landingMetaDefault() {
    return {
      ruleId: 'REPLACE',
      pathId: 'REPLACE',
      landingId: 'REPLACE'
    };
  }

  get landingMeta() {
    return this.selectedLanding?.meta
      ? {
        ruleId: +this.selectedLanding.meta[FlowHierarchyTypeEnum.rule] + 1,
        pathId: +this.selectedLanding.meta[FlowHierarchyTypeEnum.path] + 1,
        landingId: +this.selectedLanding.meta[FlowHierarchyTypeEnum.landing] + 1,
      }
      : this.landingMetaDefault;
  }

  stringify(beMobData: any) {
      let params: any = {};

      if (beMobData.cid) {
          params['c'] = beMobData.cid;
      } else {
          return '';
      }

      if (beMobData.lid) {
          params['l'] = beMobData.lid;
      } else {
          return '';
      }

      if (beMobData.fid) {
          params['f'] = beMobData.fid;
      }

      if (typeof beMobData.rid !== 'undefined') {
          params['a'] = beMobData.rid;
      } else {
          return '';
      }

      if (typeof beMobData.pid !== 'undefined') {
          params['b'] = beMobData.pid;
      } else {
          return '';
      }

      let string: any[] = [];
      let keys = Object.keys(params);
      keys.forEach((key) => {
          string.push(key + '=' + encodeURIComponent(params[key]));
      });
      return 'ns=' + encodeURIComponent(string.join('..'));
  }

  getCtaHref(num: number) {
    const { ruleId, pathId } = this.landingMeta;

    const noScriptBeMobData = this.stringify({
      cid: this.campaign_id,
      lid: this.selectedLanding.id,
      fid: this.campaign.destinationType !== 'flowInline' ? this.campaign.flowId : '',
      rid: ruleId !== 'REPLACE' ? (+ruleId - 1) : '',
      pid: pathId !== 'REPLACE' ? (+pathId - 1) : ''
    });

    return `<a href="${this.protocol}://${this.selectedDomain.domain}/click/${num}?${noScriptBeMobData}">Click me!</a>`;
  }

  get callbackCode() {
    return `
function bemobCb(params) {
    var t = params.trackingDomain+'/click/';
    var re = new RegExp(t+'?(\\\\d*)');
    var e = document.querySelectorAll('a[href*="'+t+'"]');
    for (var i = 0; i < e.length; i++) {
        var ex = re.exec(e[i].href);
        if (ex) {
            e[i].href = params.${this.protocol == 'http' ? 'ctaUrl' : 'ctaSecureUrl'}.replace('%%OFFER_NUMBER%%', ex[1] || 1);
        }
    }
}
`;
  }

  get lpPixelParams() {
    const { ruleId, pathId, landingId } = this.landingMeta;
    return `rule=${ruleId}&path=${pathId}&landing=${landingId}`;
  }

  get lpPixel() {
    const lpPixelHref = `${this.protocol}://${this.selectedDomain.domain}/landing/${this.campaign_id}?callback=bemobCb&${this.lpPixelParams}`;
    const lpPixelImgHref = `${this.protocol}://${this.selectedDomain.domain}/landing/${this.campaign_id}?${this.lpPixelParams}`;

    let lpPixel = '!function(){var a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src="'
      + lpPixelHref
      + '&"+window.location.search.substring(1);var b=document.getElementsByTagName("script")[0];b.parentNode.insertBefore(a,b)}();';
    lpPixel = '<scr' + 'ipt type="text/javascr' + 'ipt">' + lpPixel + '</scr' + 'ipt><noscr' + 'ipt><img src="' + lpPixelImgHref +'" alt=""></noscr' + 'ipt>';
    lpPixel = '<scr' + 'ipt type="text/javascr' + 'ipt">' + this.callbackCode + '</scr' + 'ipt>' + '\n' + lpPixel;

    return lpPixel;
  }

  get trackingDomains() {
    return this.$store.state.cache.trackingDomains.data
      .filter((item) => this.protocol === 'https' ? item.httpsAvailable : true);
  }


  async load() {
    const campaign: Promise<any> = this.campaignApi.get(this.campaign_id);
    const res : any = await Promise.all([campaign]);
    this.campaign = res[0];

    if(this.campaign.destinationType == 'flowInline') {
      this.flow = this.campaign.flowInline;
    } else {
      this.flow = await this.flowApi.get(this.campaign.flowId);
    }

    this.trackingDomainId = this.campaign.trackingDomainId
      ? this.campaign.trackingDomainId
      : this.$store.state.user.trackingDomainId;
  }

  async mounted() {
    this.campaign_id = this.data.id;
    this.selectedLanding = null;

    this.$store.commit('loading', true);

    if(!this.$store.state.cache.trackingDomains.isUploaded){
      await this.domainsApi.trackingDomainsPopulateStoreCache()
    }
    try {
      await this.load();
    } finally {
      this.$store.commit('loading', false);
      this.show = true;
    }
  }

  close() {
    this.$emit('close');
  }
}
